import template from './beds-count.jade';
import validation from './../../../services/validation';

export default angular
    .module('cian.addForm.bedsCount', [])
    .directive('cianAfAboutObjectBedsCount', () => ({
        scope: {},
        bindToController: {
            ad: '=',
            form: '=',
        },
        controller: ['deviceService', function (deviceService) {
            this.isMobile = deviceService.isMobile;
            this.countMax = 99;
            this.countMin = 1;

            this.validation = validation(this.form, 'bedsCount', {
                parse: 'Введите число',
                max: 'Допустимо не более 2 символов',
                min: 'Введите число',
            });
        }],
        controllerAs: 'bedsCount',
        template,
    }))
    .name;
